module.exports = {
	"id": "LK",
	"name": "Sri Lanka",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.005426,
			"5": 0.010852,
			"6": 0.008139,
			"7": 0.013565,
			"8": null,
			"9": 0.005426,
			"10": 0.013565,
			"11": 0.08139,
			"12": 0.016278,
			"13": 0.010852,
			"14": 0.008139,
			"15": 0.005426,
			"16": 0.013565,
			"17": 0.010852,
			"18": 0.008139,
			"19": 0.018991,
			"20": 0.013565,
			"21": 0.010852,
			"22": 0.013565,
			"23": 0.018991,
			"24": 0.005426,
			"25": 0.021704,
			"26": 0.013565,
			"27": 0.016278,
			"28": 0.032556,
			"29": 0.021704,
			"30": 0.035269,
			"31": 0.059686,
			"32": 0.010852,
			"33": 0.046121,
			"34": 0.010852,
			"35": 0.02713,
			"36": 0.010852,
			"37": 0.008139,
			"38": 0.024417,
			"39": 0.029843,
			"40": 0.018991,
			"41": 0.005426,
			"42": 0.037982,
			"43": 0.092242,
			"44": 0.029843,
			"45": 0.035269,
			"46": 0.024417,
			"47": 0.062399,
			"48": 0.037982,
			"49": 0.648407,
			"50": 0.056973,
			"51": 0.349977,
			"52": 0.227892,
			"53": 11.815115,
			"54": 2.82152,
			"55": 0.05426,
			"56": 0.013565,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.013565,
			"4": 0.010852,
			"5": 0.008139,
			"6": 0.005426,
			"7": 0.002713,
			"8": 0.005426,
			"9": 0.005426,
			"10": 0.016278,
			"11": 0.013565,
			"12": 0.02713,
			"13": 0.018991,
			"14": 0.016278,
			"15": 0.018991,
			"16": 0.016278,
			"17": 0.010852,
			"18": 0.013565,
			"19": 0.013565,
			"20": 0.013565,
			"21": 0.018991,
			"22": 0.010852,
			"23": 0.008139,
			"24": 0.010852,
			"25": 0.018991,
			"26": 0.008139,
			"27": 0.008139,
			"28": 0.010852,
			"29": 0.021704,
			"30": 0.02713,
			"31": 0.021704,
			"32": 0.018991,
			"33": 0.013565,
			"34": 0.016278,
			"35": 0.021704,
			"36": 0.018991,
			"37": 0.021704,
			"38": 0.032556,
			"39": 0.02713,
			"40": 0.029843,
			"41": 0.029843,
			"42": 0.02713,
			"43": 0.198049,
			"44": 0.067825,
			"45": 0.059686,
			"46": 0.056973,
			"47": 0.493766,
			"48": 0.360829,
			"49": 2.870354,
			"50": 0.168206,
			"51": 0.005426,
			"52": 0.013565,
			"3.5": 0.008139,
			"3.6": 0.029843
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": 0.005426,
			"16": 0.002713,
			"17": null,
			"18": 0.002713,
			"19": null,
			"20": 0.002713,
			"21": null,
			"22": 0.002713,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.005426,
			"29": 0.005426,
			"30": 0.008139,
			"31": null,
			"32": 0.002713,
			"33": 0.005426,
			"34": 0.016278,
			"35": 0.008139,
			"36": 0.021704,
			"37": 0.130224,
			"38": 0.013565,
			"39": 0.02713,
			"40": 0.496479,
			"41": 0.084103,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": 0.002713,
			"11.1": null,
			"11.5": null,
			"11.6": 0.005426,
			"12.1": 0.013565
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.005426,
			"6": null,
			"7": 0.005426,
			"8": 0.032556,
			"9": 0.035269,
			"10": 0.154641,
			"3.1": null,
			"3.2": null,
			"5.1": 0.013565,
			"6.1": 0.002713,
			"7.1": null,
			"9.1": 0.127511
		},
		"ios_saf": {
			"8": 0,
			"10": 1.98729441632,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0535552849709,
			"8.1-8.4": 0.0989411196919,
			"9.0-9.2": 0.0472012681099,
			"9.3": 0.720121910908
		},
		"android": {
			"3": 0,
			"4": 0.176991436693,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0221239295866,
			"4.1": 0.638433396641,
			"4.2-4.3": 1.5960834916,
			"4.4": 3.65993006589,
			"4.4.3-4.4.4": 3.69153567959
		},
		"ie": {
			"6": 0.010972913649,
			"7": 0.00274322841226,
			"8": 0.200255674095,
			"9": 0.0438916545961,
			"10": 0.0932697660167,
			"11": 0.633685763231,
			"5.5": null
		},
		"op_mob": {
			"0": 1.11898250248,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0310828472911
		},
		"edge": {
			"12": 0.078677,
			"13": 0.124798,
			"14": 0.151928
		},
		"ie_mob": {
			"10": 0.521513408451,
			"11": 2.12330459155
		},
		"bb": {
			"7": 0.0236795,
			"10": null
		},
		"samsung": {
			"0": 7.817878
		},
		"and_uc": {
			"0": 10.280546
		},
		"op_mini": {
			"0": 15.0758566502
		},
		"and_chr": {
			"0": 23.386367
		},
		"and_ff": {
			"0": 0.014572
		}
	},
	"total": 97.6467835
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LK.json
 ** module id = 575
 ** module chunks = 0
 **/